import jsPDF from 'jspdf';

export const convertJpgToPdf = async (jpgUrl) => {
    const imgData = await fetch(jpgUrl).then(r => r.blob());
    const pdf = new jsPDF();
    pdf.addImage(URL.createObjectURL(imgData), 'JPEG', 0, 0);
    return pdf.output('blob');
}
